module.exports = ".bottom-controls {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  background-color: #f6f8fa;\n  z-index: 100; }\n  .bottom-controls .btn {\n    min-width: 180px;\n    margin-right: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bottom-toolbar/bottom-toolbar.component.scss
// module id = ./src/app/components/bottom-toolbar/bottom-toolbar.component.scss
// module chunks = main